import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';

/**
 * Ask GuitarTalk on the home page. Guests get a big panel; members get a slim bar that expands.
 */
export default class AskHero extends Component {
  open = false;
  question = '';
  suggestions = [];
  oninit(vnode) {
    super.oninit(vnode);
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/ask-suggestions'
    }).then(r => {
      this.suggestions = r.data.slice(0, 4);
      m.redraw();
    });
  }
  submit(e) {
    e.preventDefault();
    const q = this.question.trim();
    if (q.length < 8) return;
    m.route.set(app.route('ask') + '?q=' + encodeURIComponent(q));
  }
  form(big) {
    return m("form", {
      className: "AskHero-form",
      onsubmit: this.submit.bind(this)
    }, m("input", {
      className: "AskHero-input",
      placeholder: big ? 'e.g. How do I stop my strings buzzing?' : 'Ask anything about guitars, gear or playing…',
      maxlength: 300,
      value: this.question,
      oninput: e => this.question = e.target.value,
      oncreate: v => !big && v.dom.focus()
    }), m("button", {
      className: "AskHero-button",
      type: "submit",
      disabled: this.question.trim().length < 8
    }, m("i", {
      className: "fas fa-wand-magic-sparkles"
    }), " Ask"));
  }
  chips() {
    return this.suggestions.length > 0 && m("div", {
      className: "AskHero-chips"
    }, this.suggestions.map(s => m(Link, {
      className: "AskHero-chip",
      href: app.route('ask.show', {
        slug: s.slug
      })
    }, s.title)));
  }
  view() {
    if (!app.session.user) {
      return m("div", {
        className: "AskHero AskHero--big"
      }, m("div", {
        className: "AskHero-badge"
      }, m("i", {
        className: "fas fa-wand-magic-sparkles"
      }), " AI \xB7 new"), m("h2", {
        className: "AskHero-title"
      }, "Ask GuitarTalk"), m("p", {
        className: "AskHero-text"
      }, "20 years of South African guitar knowledge, answered in seconds. Every answer links to the real forum threads."), this.form(true), this.chips());
    }
    return m("div", {
      className: 'AskHero AskHero--compact' + (this.open ? ' is-open' : '')
    }, this.open ? m("div", null, this.form(false), this.chips()) : m("button", {
      className: "AskHero-bar",
      onclick: () => this.open = true
    }, m("span", {
      className: "AskHero-spark"
    }, m("i", {
      className: "fas fa-wand-magic-sparkles"
    })), m("span", {
      className: "AskHero-barLabel"
    }, "Ask GuitarTalk AI"), m("span", {
      className: "AskHero-barHint"
    }, "Ask 20 years of forum threads anything\u2026")));
  }
}
flarum.reg.add('noriods-ask', 'forum/components/AskHero', AskHero);